import { createContext } from 'react';

import { type ContentLanguage } from '@@lib/i18n/constants';

const ContentLocaleContext = createContext<ContentLanguage | null>(null);

export default ContentLocaleContext;
